// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-overlay-container-centered{display:flex;position:relative;align-items:center;min-height:calc(100% - 1rem);margin-left:auto;margin-right:auto;max-width:80%}@media(min-width:576px){.video-overlay-container-centered{min-height:calc(100% - 3.5rem);margin-top:1.75rem;margin-bottom:1.75rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
